export const SITESETUP_GET = 'SITESETUP_GET';
export const SITESETUP_GET_SITEGROUPS = 'SITESETUP_GET_SITEGROUPS';
export const SITESETUP_ERROR = 'SITESETUP_ERROR';
export const SITESETUP_MAP_COLUMNS = 'SITESETUP_MAP_COLUMNS';
export const SITESETUP_POST = 'SITESETUP_POST';
export const SITESETUP_BEGIN_SUBMIT = 'SITESETUP_BEGIN_SUBMIT';
export const SITESETUP_END_SUBMIT = 'SITESETUP_END_SUBMIT';
export const SITESETUP_HAD_ERROR = 'SITESETUP_HAD_ERROR';
export const SITESETUP_CLEAR_ERRORS = 'SITESETUP_CLEAR_ERRORS';
export const SITESETUP_SET_FILTERED_DATA = 'SITESETUP_SET_FILTERED_DATA';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/page/types.js